import { useEffect, useState } from "react";
import "./Quizzes.css";
import { useNavigate, useParams } from "react-router-dom";
import { useAuthStudent } from "../../../context/StudentLoginContext/StudentAuthContext";
import { StudentMapMenuLight } from "../Map/MapMenu/MapMenuLight";
import QuizSkeleton from "../../../common/QuizSkeleton";

export const StudentAdminQuizz = () => {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedOptionIndex, setSelectedOptionIndex] = useState([]);
  const [answers, setAnswers] = useState([]);
  const { student, fetchWithAuthStudent } = useAuthStudent(); // Fetch student details from AuthContext
  const { questId, chapterId } = useParams();
  const apiUrl = process.env.REACT_APP_API_URL;
  const [quizzesMap, setQuizzesMap] = useState({ en: [], hi: [] });
  const [loading, setLoading] = useState(true);
  const [isLastQuestion, setIsLastQuestion] = useState(false);
  const [submittedAnswers, setSubmittedAnswers] = useState({});
  const [language, setLanguage] = useState(
    localStorage.getItem("language") || "en",
  );
  const navigate = useNavigate();

  // Derive the active quiz list from the cached map
  const quizes = quizzesMap[language] || [];

  const transformQuestions = (data, lang) =>
    data.map((item) => {
      const getLang = (field) =>
        field && typeof field === "object" ? field[lang] || "" : field || "";

      const options = [
        getLang(item.option1),
        getLang(item.option2),
        getLang(item.option3),
        getLang(item.option4),
      ].filter(Boolean);

      const correctAnswer = getLang(item.correctAnswer);
      const correctIndex = options.findIndex((opt) => opt === correctAnswer);

      return {
        question: getLang(item.question),
        options,
        correctAnswer,
        correctIndex,
        id: item.id,
        images: {
          question:
            item.images?.question?.[lang] || item.images?.question?.en || "",
        },
        answerExplanation: getLang(item.answerExplanation),
      };
    });

  useEffect(() => {
    const fetchQuizzes = async () => {
      if (!student || !student.token) return;

      setLoading(true);
      try {
        const response = await fetchWithAuthStudent(
          `${apiUrl}/student/quest-chapter-mcq/${chapterId}?lang=all`,
          { method: "GET" },
        );

        const data = response.ok ? await response.json() : [];

        setQuizzesMap({
          en: transformQuestions(data, "en"),
          hi: transformQuestions(data, "hi"),
        });
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    fetchQuizzes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleOptionChange = ({ target: { value }, index }) => {
    const newSubmittedAnswers = {
      ...submittedAnswers,
      [currentQuestionIndex]: {
        submitted: false,
      },
    };

    setSubmittedAnswers(newSubmittedAnswers);
    const updatedOptions = [...selectedOptions];
    updatedOptions[currentQuestionIndex] = value;
    setSelectedOptions(updatedOptions);
    const updatedOptionsIndex = [...selectedOptionIndex];
    updatedOptionsIndex[currentQuestionIndex] = index;
    setSelectedOptionIndex(updatedOptionsIndex);
  };
  const handleSubmit = () => {
    const selected = selectedOptions[currentQuestionIndex];
    const selectedIndex = selectedOptionIndex[currentQuestionIndex];
    const correct = quizes?.[currentQuestionIndex]?.correctIndex;
    const isCorrect = selectedIndex === correct;

    // Play sound based on result
    const sound = new Audio(
      isCorrect
        ? "https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/quiz-sound/correct-6033.mp3"
        : "https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/quiz-sound/wronganswer-37702.mp3",
    );
    sound.play();

    const newSubmittedAnswers = {
      ...submittedAnswers,
      [currentQuestionIndex]: {
        isCorrect,
        submitted: true,
        id: quizes[currentQuestionIndex].id,
      },
    };
    setSubmittedAnswers(newSubmittedAnswers);

    if (isCorrect) {
      const updatedAnswers = [...answers];
      updatedAnswers[currentQuestionIndex] = selected;
      setAnswers(updatedAnswers);
    }
  };

  const handleModalNext = () => {
    if (currentQuestionIndex === quizes?.length - 1) {
      setIsLastQuestion(true);
    } else {
      setCurrentQuestionIndex((prev) => prev + 1);
    }
  };
  // Use useEffect to wait for answers to update before calculating score
  useEffect(() => {
    if (isLastQuestion) {
      calculateScore(answers);
    }
  }, [answers, isLastQuestion]);

  const handlePrevious = () => {
    setCurrentQuestionIndex(currentQuestionIndex - 1);
  };
  const storeProgress = async ({ incorrectIds, correctIds }) => {
    const data = {
      studentId: String(student?.student?.id),
      questId: questId,
      chapterId: chapterId,
      incorrectQuizId: incorrectIds.length ? incorrectIds.join(",") : "", // Convert array to string
      completedQuizId: correctIds.length ? correctIds.join(",") : "", // Convert array to string
    };

    try {
      await fetchWithAuthStudent(`${apiUrl}/student/progress/store`, {
        method: "POST",
        body: JSON.stringify(data),
      });
    } catch (error) {}
  };
  const position = localStorage.getItem("chapter");
  const sendAwardTrophy = (data) => {
    fetchWithAuthStudent(`${apiUrl}/student/award-trophy`, {
      method: "POST",
      body: JSON.stringify(data),
    }).then((response) => response.json());
  };
  const calculateScore = () => {
    const correctIds = [];
    const incorrectIds = [];

    Object.values(submittedAnswers).forEach((item) => {
      if (item.id !== undefined) {
        correctIds.push(item.id);
      }
    });
    storeProgress({ incorrectIds, correctIds });
    if (position === "end") {
      const data = {
        studentId: String(student?.student?.id),
        questId: String(questId),
      };
      sendAwardTrophy(data);
      navigate(`/student/admin/congratulation/trophy/${chapterId}/${questId}`);
      return;
    }
    navigate(`/student/admin/congratulation/${chapterId}/${questId}`);
    return quizes.length;
  };
  const handleChange = (e) => {
    const selectedLang = e.target.value;
    setLanguage(selectedLang);
    localStorage.setItem("language", selectedLang);
  };
  return (
    <>
      <div
        className="StudentAdminBody"
        style={{
          position: "relative",
          backgroundColor: "#0037ac",
          minHeight: "100vh",
          zIndex: 1,
        }}
      >
        <div className="container">
          <img
            src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/quiz/LeftSide.png"
            alt="left"
            className="position-fixed "
            style={{
              left: 0,
              top: "10vh",
              height: "90vh",
              width: "auto",
              zIndex: 2,
            }}
          />

          {/* Right Image */}
          <img
            src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/quiz/RightSide.png"
            alt="right"
            className="position-fixed "
            style={{
              right: 0,
              top: "20vh",
              height: "70vh",
              width: "auto",
              zIndex: 2,
            }}
          />

          {/* Footer with highest z-index */}

          <div className="position-relative " style={{ zIndex: 3 }}>
            <div className="container col-md-3 pt-4">
              <select
                id="languageSelect"
                className="form-select"
                value={language}
                onChange={handleChange}
              >
                <option value="en">English</option>
                <option value="hi">Hindi</option>
              </select>
            </div>
            <div className="row justify-content-center">
              <div className="col-12 col-md-8">
                <div className="quiz-container p-4">
                  {loading ? (
                    <QuizSkeleton />
                  ) : (
                    <>
                      {/* Progress Bar */}
                      <div className="d-flex justify-content-between mb-4 mt-4">
                        {quizes.map((_, index) => (
                          <span
                            key={index}
                            className={`progress-line ${
                              index <= currentQuestionIndex ? "active" : ""
                            }`}
                          ></span>
                        ))}
                      </div>

                      {/* Question */}
                      <h5 className=" text-center  questionNoText ">
                        Question {currentQuestionIndex + 1}/{quizes?.length}
                      </h5>
                      {quizes[currentQuestionIndex]?.images?.question && (
                        <div className="QuizImageCard">
                          <img
                            src={quizes[currentQuestionIndex]?.images?.question}
                            alt="question"
                          />
                        </div>
                      )}
                      <p className="text-center  my-4 questionText">
                        {quizes?.[currentQuestionIndex]?.question}
                      </p>

                      {/* Options */}
                      <div className="options-container">
                        {quizes?.[currentQuestionIndex]?.options?.map(
                          (option, index) => {
                            const isSelected =
                              selectedOptionIndex[currentQuestionIndex] ===
                              index;
                            const submissionInfo =
                              submittedAnswers[currentQuestionIndex];
                            const isSubmitted = submissionInfo?.submitted;
                            const isAnswerCorrect = submissionInfo?.isCorrect;

                            return (
                              <>
                                <div
                                  key={index}
                                  className={`option d-flex align-items-center`}
                                  onClick={() =>
                                    handleOptionChange({
                                      target: { value: option },
                                      index,
                                    })
                                  }
                                  style={{
                                    cursor: isSubmitted ? "default" : "pointer",
                                    backgroundColor: (() => {
                                      if (isSelected) {
                                        if (!isSubmitted) return "#007BFF";
                                        return isAnswerCorrect
                                          ? "#23B816"
                                          : "#FF0000";
                                      }
                                      return "";
                                    })(),
                                    color: isSelected ? "white" : "black",
                                    transition:
                                      "background-color 0.5s ease-in-out",
                                  }}
                                >
                                  <input
                                    type="radio"
                                    name={`option-${currentQuestionIndex}`}
                                    value={option}
                                    id={`option${index}`}
                                    checked={isSelected}
                                    onChange={handleOptionChange}
                                    style={{ display: "none" }}
                                  />
                                  <span className="option-label">
                                    {String.fromCharCode(65 + index)}
                                  </span>
                                  <span className="option-text">{option}</span>
                                </div>

                                {isSelected &&
                                  isAnswerCorrect &&
                                  Boolean(
                                    quizes[currentQuestionIndex]
                                      ?.answerExplanation &&
                                    String(
                                      quizes[currentQuestionIndex]
                                        ?.answerExplanation,
                                    ).trim(),
                                  ) && (
                                    <>
                                      <div>
                                        <i className="bi bi-lightbulb-fill colored-lightbulb"></i>{" "}
                                        <span
                                          className="text-white fs-5"
                                          style={{ fontWeight: 600 }}
                                        >
                                          {language === "hi"
                                            ? "जानकारी"
                                            : "Trivia"}{" "}
                                        </span>
                                        <span className="text-white fs-5">
                                          :{" "}
                                        </span>
                                        <span className="text-white fs-5">
                                          {
                                            quizes[currentQuestionIndex]
                                              ?.answerExplanation
                                          }
                                        </span>
                                      </div>
                                    </>
                                  )}
                              </>
                            );
                          },
                        )}
                      </div>
                      {submittedAnswers[currentQuestionIndex]?.submitted &&
                        !submittedAnswers[currentQuestionIndex]?.isCorrect && (
                          <p className="text-white mt-2 fs-5">
                            {language === "hi"
                              ? "आपने ग़लत उत्तर चुना है |"
                              : "You have selected the wrong answer."}
                          </p>
                        )}

                      {/* Navigation Buttons */}
                      <div className="d-flex justify-content-between mt-4">
                        {currentQuestionIndex !== 0 && (
                          <button
                            className="btn quizChange "
                            onClick={handlePrevious}
                          >
                            {language === "hi" ? "पीछे" : "Back"}
                          </button>
                        )}
                        {submittedAnswers[currentQuestionIndex]?.submitted &&
                          submittedAnswers[currentQuestionIndex]?.isCorrect && (
                            <button
                              className="btn quizChange "
                              onClick={handleModalNext}
                            >
                              {currentQuestionIndex === quizes?.length - 1
                                ? language === "hi"
                                  ? "सबमिट करें"
                                  : "Submit"
                                : language === "hi"
                                  ? "अगला"
                                  : "Next"}
                            </button>
                          )}
                        {!submittedAnswers[currentQuestionIndex]?.isCorrect && (
                          <button
                            className="btn quizChange "
                            onClick={handleSubmit}
                          >
                            {language === "hi" ? "उत्तर देखे" : "Check Answer"}
                          </button>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style={{ position: "relative", zIndex: 4 }}>
          <StudentMapMenuLight />
          {/* <StudentFooter /> */}
        </div>
      </div>
    </>
  );
};
